import { createSlice } from "@reduxjs/toolkit";

const themeSlice = createSlice({
    name: "theme",
    initialState: {
        currentTheme: "Default",
    },
    reducers:{
        setTheme: (state, action) => {
            state.currentTheme = action.payload;
        },
    },
    
});

export const {setTheme} = themeSlice.actions;
export default themeSlice.reducer;